import { call, takeEvery, put } from 'redux-saga/es/effects';
import * as actionTypes from './actionTypes';
import { getTerminalListCall } from '../../../terminals/sagas';
import { listInterfacesCall } from '../../../interfaces/sagas';
import axios from 'axios';
import {
    LOAD_WIDGET_DATA_SUCCESS,
    LOAD_WIDGET_DATA_FAILED
} from '../../actionTypes';

const getChartData = (widgetId, searchData) => new Promise((resolve, reject) => {
    axios.get("/widgets/chart-readings/" + widgetId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

function* fetchChartData({ id, searchData }) {
    try {
        const data = yield call(getChartData, id, searchData);
        yield put({
            type: LOAD_WIDGET_DATA_SUCCESS,
            id: id,
            data: data
        })
    } catch (e) {
        yield put({
            id: id,
            type: LOAD_WIDGET_DATA_FAILED
        });
    }
}

function* fetchTerminalsOfEntity({ entityId }) {
    try {
        const terminalList = yield call(getTerminalListCall, { entityId });
        yield put({
            type: actionTypes.FETCH_TERMINALS_OF_ENTITY_SUCCESS,
            terminalList: terminalList.map(terminal => ({ value: terminal.id, label: terminal.name })),
            entityId
        });
    } catch (e) {
        yield put({
            type: actionTypes.FETCH_TERMINALS_OF_ENTITY_FAILED
        });
    }
}

function* fetchInterfacesOfEntity({ entityId }) {
    try {
        const entityInterfaceList = yield call(listInterfacesCall, { entityId });
        yield put({
            type: actionTypes.FETCH_INTERFACES_OF_ENTITY_SUCCESS,
            interfaceList: entityInterfaceList.map(iface => ({ value: iface.id, label: iface.name, category: iface.category.value })),
            entityId
        });
    } catch (e) {
        yield put({
            type: actionTypes.FETCH_INTERFACES_OF_ENTITY_FAILED
        });
    }
}

function* fetchInterfacesOfTerminal({ terminalId }) {
    try {
        const terminalInterfaceList = yield call(listInterfacesCall, { terminalId });
        yield put({
            type: actionTypes.FETCH_INTERFACES_OF_TERMINAL_SUCCESS,
            interfaceList: terminalInterfaceList.map(iface => ({ value: iface.id, label: iface.name, category: iface.category.value })),
            terminalId
        });
    } catch (e) {
        yield put({
            type: actionTypes.FETCH_INTERFACES_OF_TERMINAL_FAILED
        });
    }
}

function* fetchUnitsOfCategory(/*{ interfaceCategory }*/) {
    // Backend does not support unit type listing by interface category;
    // This will be on hold until then
    yield put({
        type: actionTypes.FETCH_UNITS_OF_CATEGORY_SUCCESS,
        unitList: []
    });
}

const chartConfigsSagas = [
    takeEvery(actionTypes.FETCH_TERMINALS_OF_ENTITY_REQUEST, fetchTerminalsOfEntity),
    takeEvery(actionTypes.FETCH_INTERFACES_OF_ENTITY_REQUEST, fetchInterfacesOfEntity),
    takeEvery(actionTypes.FETCH_INTERFACES_OF_TERMINAL_REQUEST, fetchInterfacesOfTerminal),
    takeEvery(actionTypes.FETCH_UNITS_OF_CATEGORY_REQUEST, fetchUnitsOfCategory),
    takeEvery(actionTypes.LOAD_CHART_WIDGET_DATA_REQUEST, fetchChartData)
];

export {
    chartConfigsSagas
};